import axios from 'axios'
import {toData} from "./util";

export function getActive(id, subsidiaryId): Promise {
  return axios.get(`/api/memberships/group/${id}?subsidiaryId=${subsidiaryId}`).then(toData)
}

export function update(membership): Promise {
  return axios.put('/api/memberships', membership).then(toData)
}
